import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { colors } from '../styles';
import { connect } from 'react-redux';
import { msgSimple, msgAction } from '../actions/snackbarActions';
import { navigate } from '../actions/routerResolve';

import ColorService from '../tools/ColorsService';

class View extends Component {
    handleColor = () => {
        switch (this.props.status) {
            case 'EmAndamento':
                return colors.green500;
            case 'Agendado':
                return colors.primary;
            case 'Programado':
                return colors.primary;
            case 'Confirmado':
                return colors.yellow500;
            case 'Solicitado':
                return colors.white;
            case 'Cancelado':
                return colors.regular;
            case 'Alterado':
                return colors.red500;
            default:
                return colors.regular;
        }
    }
    handleTextColor = () => {
        switch (this.props.status) {
            case 'EmAndamento':
                return colors.white;
            case 'Agendado':
                return colors.white;
            case 'Programado':
                return colors.white;
            case 'Confirmado':
                return colors.white;
            case 'Solicitado':
                return colors.regular;
            case 'Cancelado':
                return colors.white;
            case 'Alterado':
                return colors.white;
            default:
                return colors.white;
        }
    }
    render() {
        return (
            <Grid container style={{ backgroundColor: ColorService.backgroundColor(this.props.status), height: 150 }}>
                <Grid container>
                    <Grid container justify='center' alignItems='center' item md={12} sm={12} style={{ fontFamily: 'Roboto', justifyItems: 'center', color: colors.white, alignItems: 'center', textAlign: 'center' }} >
                        <Grid container spacing={24} justify='center' item md={12} style={{ marginTop: 2 }}>
                            {/* {
                                this.props.id === 'new' ? (
                                    <Grid container item alignItems='center' justify='flex-end' xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Button
                                            size='large'
                                            onClick={()=>this.props.handleSaveMission()}
                                            color="primary"
                                            style={{ backgroundColor: colors.primary_darker, color: 'white' }}
                                        >
                                            Salvar
                                                            </Button>
                                        <Button
                                            size='large'
                                            onClick={() => this.props.navigate('/')}
                                            style={{color:ColorService.contrastColor(this.props.status)}}
                                        >
                                            Cancelar
                                                            </Button>
                                    </Grid>
                                ) : (
                                    <Grid container item alignItems='center' justify='flex-end' xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button
                                        size='large'
                                        onClick={()=>this.props.handleUpdateMission()}
                                        color="primary"
                                        style={{ backgroundColor: colors.primary_darker, color: 'white' }}
                                    >
                                        Atualizar
                                                        </Button>
                                    <Button
                                        size='large'
                                        onClick={() => this.props.navigate('/')}
                                        style={{color:ColorService.contrastColor(this.props.status)}}
                                    >
                                        Cancelar
                                                        </Button>
                                </Grid>
                                    )
                            } */}
                        </Grid>
                        <Grid style={{ paddingTop: -5 }} container justify='center' item md={12}>
                            <h3 style={{ margin: 5, color: this.handleTextColor() }} >{this.props.title}</h3><br />
                        </Grid>
                        <Grid container justify='center' item md={12}>
                            <span style={{ marginBottom: 15, color: this.handleTextColor(), }} >Campos Obrigatórios*</span>
                        </Grid>
                        <Grid container justify='center' item md={12}>
                        </Grid>
                        <Grid container justify='center' item md={12}>
                        </Grid>
                        <Grid container justify='center' item md={12}>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => ({
    users: state.usersReducer.users
})

const mapDispatchToProps = {
    msgSimple,
    msgAction,
    navigate
};

export default connect(mapStateToProps, mapDispatchToProps)(View)



// WEBPACK FOOTER //
// ./src/components/View.js